import {$, Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {IFaturamentoResourcesHolder} from '@/interfaces/resource/IFaturamentoResourcesHolder'
import {DashboardFilterCollection} from '@/model/filter/DashboardFilterCollection'

export class DashboardFilterSchema extends Schema
  implements IFaturamentoResourcesHolder {
  readonly name = 'DashboardFilter'

  readonly fieldSet: FieldSet<DashboardFilterCollection> = {
    anoAsResource: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        items: schema.model.yearList?.all(),
        label: this.translateFrom(schema.fieldName),
        allowEmpty: false,
      },
    }),
  }
}
